module.exports = __webpack_public_path__ + "media/images/header_logo-c75916e0e8ef81dca7d4a468268f5636.png";